// src/pages/Upload.js
import React from 'react';
import { useState } from 'react';
import { Container } from 'reactstrap';
import RecentCertificates from '../../components/RecentCertificate/RecentCertificate';

export default function Blockchain() {
  const [file, setFile]     = useState(null);
  const [status, setStatus] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    if (!file) return;
    setStatus('Enviando...');
    const form = new FormData();
    form.append('file', file);
    try {
      const res = await fetch(
        'https://proxy-service-236688625650.southamerica-east1.run.app/',
        { method: 'POST', body: form }
      );
      if (!res.ok) throw new Error(await res.text());
      setStatus('✔ Certificado criado!!!!');
    } catch (err) {
      console.error(err);
      setStatus('❌ Falha no envio');
    }
  }

  return (
    <Container fluid style={{marginTop: "10rem"}}>
      <h1 style={{color: "#bbd259"}}>
        Gerar NFT
      </h1>
      <p>Registre seu arquivo na Sepolia Ethereum, salvando o arquivo na rede Pinata.</p>
      <form onSubmit={handleSubmit}>
        <input
          type="file"
          onChange={e => setFile(e.target.files[0])}
        />
        <button
          style={{backgroundColor: "#bbd259", width: "100%", color: "white", borderRadius: "0.375rem", border: 'none', padding: '5px 0px', transition: "background-color 0.5s"}}
          onMouseEnter={(e) => {e.target.style.backgroundColor = "#a3b84d"}}
          onMouseLeave={(e) => {e.target.style.backgroundColor = "#bbd259"}}
          type="submit"
        >
          Enviar
        </button>
      </form>
      {status && <p className="mt-4 text-center">{status}</p>}

      <RecentCertificates /> {/* e aqui, após importar */}

    </Container>
  )
}
